var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"body"}},[_c('postpone-topnav'),_vm._v(" "),_c('main',[_c('Nuxt')],1),_vm._v(" "),_c('postpone-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }